export default function CollaborationSection() {
  const collaborations = [
    {
      title: "브랜드 협업",
      description: "지속가능한 가치를 함께 만들어가는 브랜드 파트너십",
      details: [
        "업사이클 제품 기획 및 생산",
        "친환경 패션 컬렉션 협업",
        "브랜드 스토리텔링 공동 개발",
        "지속가능성 캠페인 협력"
      ],
      image: "https://public.readdy.ai/ai/img_res/3f613b1c36835aabcf296954b719f441.jpg"
    },
    {
      title: "소재 협업",
      description: "혁신적인 기능성 소재 개발 및 적용",
      details: [
        "에어로젤 코팅 섬유 기술 적용",
        "고기능성 소재 공동 연구",
        "친환경 소재 개발 협력",
        "산업용 특수 소재 맞춤 제작"
      ],
      image: "https://readdy.ai/api/search-image?query=advanced%20textile%20materials%20research%20laboratory%20high-tech%20fabric%20samples%20aerogel%20coating%20technology%20scientists%20examining%20functional%20materials%20clean%20modern%20workspace%20innovative%20textiles%20close-up&width=800&height=600&seq=partnership-material-collab&orientation=landscape"
    },
    {
      title: "생산 협력",
      description: "전문 기술력을 바탕으로 한 생산 파트너십",
      details: [
        "소량 맞춤 생산 지원",
        "고품질 봉제 기술 제공",
        "산업용 워크웨어 제작",
        "지속가능한 생산 프로세스 구축"
      ],
      image: "https://readdy.ai/api/search-image?query=professional%20sewing%20production%20workshop%20skilled%20workers%20operating%20industrial%20sewing%20machines%20quality%20workwear%20manufacturing%20organized%20factory%20floor%20natural%20lighting%20craftsmanship%20textile%20production&width=800&height=600&seq=partnership-production-collab&orientation=landscape"
    }
  ];

  return (
    <section className="py-32 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-20">
          <h2 className="text-5xl font-bold text-[#2C3E2E] mb-6">협업</h2>
          <p className="text-xl text-[#5A6B5C] max-w-2xl mx-auto">
            Daygreen과 함께 지속가능한 가치를 만들어갑니다
          </p>
        </div>

        <div className="space-y-24">
          {collaborations.map((collab, index) => (
            <div 
              key={index}
              className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} gap-12 items-center`}
            >
              <div className="flex-1">
                <div className="relative h-[400px] rounded-lg overflow-hidden">
                  <img
                    src={collab.image}
                    alt={collab.title}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
              
              <div className="flex-1">
                <h3 className="text-4xl font-bold text-[#2C3E2E] mb-4">
                  {collab.title}
                </h3>
                <p className="text-lg text-[#5A6B5C] mb-8 leading-relaxed">
                  {collab.description}
                </p>
                <ul className="space-y-4">
                  {collab.details.map((detail, idx) => (
                    <li key={idx} className="flex items-start gap-3">
                      <div className="w-2 h-2 rounded-full bg-[#7A9B76] mt-2 flex-shrink-0"></div>
                      <span className="text-[#2C3E2E] text-lg">{detail}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}